import { CartId } from 'lib/types'
import { getIsLoggedIn } from 'lib/core/data/auth/session/selectors'
import { localStorage } from 'lib/core/services/localStorage'
import { getCartId as getCustomerCartId } from 'lib/core/data/customer/cartId/selectors'
import { RootState } from 'lib/core/data/reducer'

export const getCartId = (state: RootState): CartId => {
  const isLoggedIn = getIsLoggedIn(state)
  const customerCartId = getCustomerCartId(state)
  return isLoggedIn ? customerCartId : localStorage.get('cartToken')
}
